import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const GoogleOutlined24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.googleFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm0 1.198C6.815 2.198 2.198 6.815 2.198 12.5S6.815 22.802 12.5 22.802 22.802 18.185 22.802 12.5 18.185 2.198 12.5 2.198zM12.75 8c1.195 0 2.211.41 3.01 1.088l.168.15-1.362 1.362c-.492-.471-1.119-.71-1.816-.71-1.237 0-2.284.835-2.658 1.957-.095.286-.149.59-.149.903 0 .313.054.617.15.902.373 1.123 1.42 1.959 2.657 1.959.56 0 1.046-.13 1.443-.352l.166-.102.16-.118c.368-.295.627-.688.748-1.142l.04-.173H12.75v-1.838h4.474c.056.311.086.635.086.972 0 1.447-.518 2.664-1.416 3.491-.786.726-1.861 1.151-3.144 1.151a4.747 4.747 0 01-4.143-2.425l-.102-.192-.114-.244a4.746 4.746 0 010-3.778l.114-.244.102-.192A4.747 4.747 0 0112.75 8z"
      fillRule="evenodd"
    />
  </svg>
);

export default GoogleOutlined24;
